<template>
  <div class="cobrowse-client">
    <div class="cobrowse-client-leftinfo">
      <div class="cobrowse-client-leftinfo-top">
	  <div id="logo"/></div>
	  <!--
        <div class="">{{getLanguage("ROOMID")}}: {{roomId}}</div>
        <div v-show="password">{{getLanguage("PASSWORD")}}: {{password}}</div>
      </div>
      <div class="cobrowse-client-leftinfo-bottom">
        <div class=""><span>{{getLanguage("DURATION")}}: </span><span>{{conventTimeFormat(duration)}}</span></div>
        <span class="break-line" @click="changeLanguage" ></span>
        <div>{{getLanguage("PARTICIPANTS")}}: {{participants}}</div>
      </div>
	  -->
    </div>
    <div class="cobrowse-client-rightinfo">
      <div class="cobrowse-client-participants" v-show="isParticipantsButtonShow">
        <div>
          <svg width="52" height="37" viewBox="0 0 52 37" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M35.5934 16.2609C39.5594 16.2609 42.5923 12.949 42.5923 8.61801C42.5923 4.28703 39.5594 0.975098 35.5934 0.975098C31.6273 0.975098 28.5944 4.28703 28.5944 8.61801C28.5944 12.949 31.6273 16.2609 35.5934 16.2609ZM16.9295 16.2609C20.8956 16.2609 23.9285 12.949 23.9285 8.61801C23.9285 4.28703 20.8956 0.975098 16.9295 0.975098C12.9634 0.975098 9.93056 4.28703 9.93056 8.61801C9.93056 12.949 12.9634 16.2609 16.9295 16.2609ZM16.9295 21.3562C11.5636 21.3562 0.598633 24.4134 0.598633 30.2729V36.642H33.2604V30.2729C33.2604 24.4134 22.2954 21.3562 16.9295 21.3562ZM35.5934 21.3562C34.8935 21.3562 34.1936 21.3562 33.2604 21.611C36.06 23.6491 37.9263 26.7062 37.9263 30.2729V36.642H51.9242V30.2729C51.9242 24.4134 40.9592 21.3562 35.5934 21.3562Z" fill="white"/>
          </svg>
        </div>
      </div>
      <div class="cobrowse-client-voice" id="client-voice" v-show="isChatButtonShow">
        <div>
          <span class="cobrowse-client-voice-counter" v-show="voiceCounter > 0">{{voiceCounter}}</span>
          <svg width="41" height="46" viewBox="0 0 41 46" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20.3717 0.327637C9.07849 0.327637 0.0439453 8.54086 0.0439453 18.8074V33.1805C0.0439453 36.6711 2.98017 39.3404 6.81985 39.3404H13.5958V22.914H4.56122V18.8074C4.56122 10.7995 11.563 4.43425 20.3717 4.43425C29.1803 4.43425 36.1821 10.7995 36.1821 18.8074V22.914H27.1476V39.3404H36.1821V41.3937H20.3717V45.5003H33.9235C37.7632 45.5003 40.6994 42.831 40.6994 39.3404V18.8074C40.6994 8.54086 31.6648 0.327637 20.3717 0.327637Z" fill="white"/>
          </svg>
        </div>
      </div>
      <div class="cobrowse-client-screenrecording" v-show="isScreenRecording"><div class="screen-text">
          <div></div>
          <div>{{getLanguage("SCREEN_RECORDING")}}</div>
      </div></div>
      <div class="cobrowse-client-finish" v-show="this.userType=='agent'"><div @click="completeRoom">
        <svg width="43" height="33" viewBox="0 0 43 33" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14.0729 25.7844L4.29388 15.8892L0.963867 19.235L14.0729 32.4999L42.2139 4.02434L38.9073 0.678467L14.0729 25.7844Z" fill="white"/>
        </svg>
      </div></div>
      <div class="cobrowse-client-exit" v-show="this.userType=='client'"><div @click="leaveRoom">
	  <div class="leave-image"></div>
		<!--
        <svg width="70" height="57" viewBox="0 0 70 57" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M63.6364 0H6.36364C2.86364 0 0 2.85317 0 6.34038V18.9894H6.36364V6.27697H63.6364V50.7547H6.36364V38.0106H0V50.723C0 54.2102 2.86364 57 6.36364 57H63.6364C67.1364 57 70 54.2102 70 50.723V6.34038C70 2.82147 67.1364 0 63.6364 0ZM31.8182 41.1808L44.5455 28.5L31.8182 15.8192V25.3298H0V31.6702H31.8182V41.1808Z" fill="#575757"/>
        </svg>
		-->
      </div></div>
    </div>

    <br>
    <input type="text" name="sessionId" id="sessionId" placeholder="Session ID..." />
    <input type="text" name="roomId" id="roomId" placeholder="Room ID..." />
    <button id="createRoomBtn" type="button">Open Room</button>
    <div id="pointer"><div id="pointer-label">Client</div></div>
    <div id="adminPointer"><div id="adminPointer-label">Agent</div></div>
    <button id="ctilCanvasClearBtn">Clear Canvas</button>
    <button id="ctilCanvasLayerSwitch">Layer Off</button>
    <div id="ctilCanvasContentBtn">
      <div id="content-btn" class="icon-no-draw"></div>
      <ul id="content-menu">
        <li class="menu-icon"><button id="no-draw"></button></li>
        <li class="menu-icon"><button id="draw-retangle"></button></li>
        <li class="menu-icon"><button id="draw-circle"></button></li>
      </ul>
    </div>
    <canvas id="CTILCanvas"></canvas>
    <canvas id="CTILCanvasAdmin"></canvas>
  </div>
</template>

<script>
import langChi from "../lang/lang.chi.js";
import langEng from "../lang/lang.eng.js";
import { getLanguageByKey } from "../util/languageConvert";

export default {
  name: 'CobrowseClient',
  data(){
    return {
      roomInfo: {

      },
      roomId: null,
      password: null,
      duration: null,
      participants: null,
	  isChatButtonShow: false,
	  isParticipantsButtonShow: false,
	  isScreenRecording: true,
	  isCompleteButtonShow: false,
	  timer: '',
      voiceCounter: 1,
	  selectLanguage:'en',
	  userType: null,
    }
  },
  props: {
    //roomInfo: Object
  },
  mounted: function() {
    //this.roomId = "test",
    //this.password = "password",
    //this.duration = "00:20",
    //this.participants = "Adam Wong";
    window.ctilEventBus.on("ctilcobrowseInfo", event => {
        console.log('[ctilEventBus] ctilcobrowseInfo', event.detail);
	    var data = event.detail;
		this.roomId = data.roomId;
		this.password = data.password;
		this.duration = data.time;
		this.participants = data.participants.toString();
		this.isChatButtonShow = data.isChatButtonShow;
		this.isParticipantsButtonShow = data.isParticipantsButtonShow;	
    });
	console.log("isChatButtonShow" + this.isChatButtonShow)
	console.log("isParticipantsButtonShow" +this.isParticipantsButtonShow)
	console.log("isScreenRecording" + this.isScreenRecording)
	console.log("isCompleteButtonShow" +this.isCompleteButtonShow)
	
	this.timer = setInterval(this.setTimer, 1000);
	
	window.ctilEventBus.on("ctilUserInfo", event => {
		console.log('[ctilEventBus] ctilUserInfo', event.detail)
		console.log(event)
		console.log("userInfo: "+event.detail.userType)
		this.userType = event.detail.userType;
	})
	console.log("userType"+this.userType)
	
	window.ctilEventBus.on("ctilStartRecorder", event => {
		console.log('[ctilEventBus] ctilStartRecorder', event.detail)
		console.log(event)
		this.isScreenRecording = true;
	})
	
	console.log("isScreenRecording"+this.isScreenRecording)	
/*
	window.ctilEventBus.on("getLanguageType", event => {
		console.log('[ctilEventBus] getLanguageType', event.detail);
		this.selectLanguage = event.detail.language;
		console.log(this.selectedLanguage)
	})
*/
    document.getElementById("createRoomBtn").style.visibility = "hidden";
    document.getElementById("sessionId").style.visibility = "hidden";
		document.getElementById("roomId").style.visibility = "hidden";
    var _this = this;
    // this.$nextTick(function(){ _this._setup() });
  },
  methods:{
    getLanguage(key) {
      //return key;
	  return getLanguageByKey(langEng.wordings, key);
	  /*
	  if( this.selectLanguage == 'en'){
		return getLanguageByKey(langEng.wordings, key);
	  }else{
		return getLanguageByKey(langChi.wordings, key);
	  }
	  */
    },
    leaveRoom () {
      console.log("click the eventbus")
      window.ctilEventBus.emit("leaveRoom", {status: "LEAVE"});
    },
    completeRoom () {
      console.log("click the completeRoom")
      window.ctilEventBus.emit("leaveRoom", {status:"COMPLETE"});
    },
    _setup(){
      /**
       * Add the image for the cursor pointer
       */
      const cursorImagePath = window.ctilcobrowse.getAssetsRootPath();
      document.getElementById("pointer").style.backgroundImage = "url('" + cursorImagePath + "cursor-default-outline.png')";
      document.getElementById("adminPointer").style.backgroundImage = "url('" + cursorImagePath + "cursor-default-black.png')";

      /**
       * The button setting for create room (for development testing)
       */
      document.getElementById("createRoomBtn").addEventListener("click", function () {
        var sessionId = document.getElementById("sessionId").value;
        var roomId = document.getElementById("roomId").value;
        if (sessionId && sessionId != "" && roomId && roomId != "") {
          document.getElementById("createRoomBtn").style.display = "none";
          document.getElementById("sessionId").style.display = "none";
          document.getElementById("roomId").style.display = "none";
          localStorage.setItem("sessionId",sessionId);
          localStorage.setItem("roomId",roomId);
          window.ctilcobrowse.createRoom(sessionId, roomId, "Customer1234567890");
        }
      });
      
      /*
      document.getElementById("submitBtn").addEventListener("click", function () {
        var id = document.getElementById("octopusID").value
        var firstName = document.getElementById("firstName").value;
        var lastName = document.getElementById("lastName").value;
        var birthday = document.getElementById("datepicker").value;
        var age = document.getElementById("age").value;
        var postAddr = document.getElementById("postAddr").value;
        var contactNumber = document.getElementById("contactNumber").value;
        var email = document.getElementById("email").value;
        var obj = {
          id: id,
          firstName: firstName,
          lastName: lastName,
          birthday: birthday,
          age: age,
          postAddr: postAddr,
          contactNumber: contactNumber,
          email: email
        }
        localStorage.setItem("customerResult", JSON.stringify(obj));
        location.href = "http://localhost:8086/examples/customer_success.html";
      });
      */
    },
	setTimer(){
	this.duration = parseInt(this.duration)+1;
	},
	conventTimeFormat(time){
	   if (time > 0) {
        var hours = Math.floor(time / 3600);
        var minutes = Math.floor(time / 60) %60;
        var seconds = time % 60;
        if (hours < 10) {
          hours = "0" + hours;
        }
        if (minutes < 10) {
          minutes = "0" + minutes;
        }
        if (seconds < 10) {
          seconds = "0" + seconds;
        }
        return hours + ":" + minutes + ":" + seconds;
      } else {
        return "00:00:00";
      }
	},
	clearTimer(){
		console.log("Click clear timer")
		clearInterval(this.timer)
	},
	changeLanguage(){
	console.log("language change")
		if(this.selectLanguage == 'zh-hant'){
			this.selectLanguage = 'en'
		}else{
			this.selectLanguage = 'zh-hant'
		}
		console.log(this.selectLanguage)
	}
  },
}
</script>

<style scoped>
*{
  box-sizing: border-box;
}

.break-line{
    width: 0px;
    height: 76%;
    border: 1.2px solid #EC7923;
    margin: 0 18px;
}

.cobrowse-client{
  height:100%;
}

.cobrowse-client-leftinfo, .cobrowse-client-rightinfo{
  float:left;
  height: 100%;
  padding: 10px;
}

.cobrowse-client-leftinfo{
  width: 50%;
  display:block;
}

.cobrowse-client-leftinfo-top{
  height: 100%;
  color: #2C636D;
  display:inline-block;
  align-items: center;
  font-weight: 500;
  font-size:20px;
  width:50%;
}

.cobrowse-client-leftinfo-bottom{
  height: 50%;
  color: #575757;
  display:flex;
  align-items: center;
  font-weight: 500;
  font-size:17px;
}


.cobrowse-client-leftinfo-top > div{
  padding-right: 30px;
}

.cobrowse-client-rightinfo{
  width: 50%;
  display: flex;
  float:right;
  justify-content: flex-end;
}

.cobrowse-client-rightinfo > div{
  float: left;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
/*
.cobrowse-client-screenrecording{
    margin: 0 60px 0 20px;
}
*/
.cobrowse-client-participants,
.cobrowse-client-voice,
.cobrowse-client-finish{
  margin: 0 10px;
}
/*
.cobrowse-client-exit{
  margin: 0px 32px 0 20px;
}
*/
.cobrowse-client-exit > div{
  cursor: pointer;
}

.cobrowse-client-participants > div,
.cobrowse-client-voice > div{
  height: 50px;
  width: 50px;
  background: #D87C3A;
  border-radius: 50%;
  display:flex;
  justify-content: center;
  align-items: center;  
  position: relative;
  cursor: pointer;
}

.cobrowse-client-participants svg,
.cobrowse-client-voice svg{
  height: 32px;
  width: 32px;
}

.cobrowse-client-voice .cobrowse-client-voice-counter{
  position:absolute;
  height: 20px;
  width: 20px;
  display:flex;
  justify-content: center;
  align-items: center;  
  background: #2C636D;
  border-radius: 50%;
  color: white;
  top: -5px;
  right: -5px;
  font-size: 12px;
  pointer-events: none;
}


.cobrowse-client-finish > div{
  height: 45px;
  width: 45px;
  background: #3DB249;
  border-radius: 50%;
  display:flex;
  justify-content: center;
  align-items: center;  
}

.cobrowse-client-finish svg {
    height: 30px;
    width: 30px;
}

.cobrowse-client-screenrecording > div{
    display: flex;
    justify-content: center;
    align-items: center;
}

.cobrowse-client-screenrecording > div > div:nth-child(1){
  border-radius: 50%;
  height: 28px;
  width: 28px;
  display: flex;
  justify-content: center;
  align-items: center; 
  margin: 0 10px;
}

.cobrowse-client-screenrecording > div > div:nth-child(1)::after{
  content: "\25C9";
  height: 16px;
  width: 16px;
  color: #AF0000;
  font-size: 34px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.cobrowse-client-exit svg {
    height: 45px;
    width: 45px;
}

.leave-image{
	height: 65px;
	width:65px;
	background-size: 100%;
	background-image: url(../assets/close_icon.png);
}
</style>



<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#CTILCanvas {
  /*border: solid 1px black;*/
  position: absolute;
  top: 0;
  left: 0;
  width: 0px;
  height: 0px;
  /*display: none;*/
}
#CTILCanvasAdmin {
  /*border: solid 1px blue;*/
  position: absolute;
  top: 0;
  left: 0;
  width: 0px;
  height: 0px;
  /*display: none;*/
}
#ctilCanvasClearBtn {
  position: fixed;
  bottom: 100px;
  right: 10px;
  border-radius: 50%;
  width: 70px;
  height: 70px;
  border: none;
  background-color: orange;
  z-index: 999;
  display: none;
  outline: 0;
}
#ctilCanvasLayerSwitch {
  position: fixed;
  bottom: 190px;
  right: 10px;
  border-radius: 50%;
  width: 70px;
  height: 70px;
  border: none;
  background-color: orange;
  z-index: 999;
  display: none;
  outline: 0;
}

#ctilCanvasContentBtn {
  position: fixed;
  bottom: 10px;
  right: 10px;
  border-radius: 50%;
  width: 70px;
  height: 70px;
  display: none;
  outline: 0;
  z-index: 999;
}
#content-btn {
  position: relative;
  border-radius: 50%;
  width: 70px;
  height: 70px;
  border: none;
  background-color: orange;
  z-index: 999;
  margin: 0;
  padding: 0;
  outline: 0;
}
#content-menu {
  position: absolute;
  right: 35px;
  bottom: 0px;
  width: 0;
  height: 70px;
  background-color: black;
  z-index: 998;
  list-style-type: none;
  margin: 0;
  padding: 0;
  border-bottom-left-radius: 40px;
  border-top-left-radius: 40px;
  display: flex;
  flex-wrap: nowrap;
  /*justify-content: center;*/
  align-items: center;
  -moz-transition: all 0.3s;
  -o-transition: all 0.3s;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
}
#content-menu.expand {
  width: 280px;
  box-sizing: border-box;
  padding-left: 30px;
}
#content-menu .menu-icon {
  width: 70px;
  height: 100%;
  /*border: solid 1px green;*/
  opacity: 0;
}
#content-menu .menu-icon button {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: none;
  background-color: transparent;
}
</style>

<style scoped>
#pointer {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-32%, -10%);
  width: 20px;
  height: 20px;
  display: none;
  z-index: 1000;
  /*background: rgba(25, 181, 254, 1);*/
  /*background-image: url('../assets/cursor-default-outline.png');*/
  background-size: cover;
  /*border: 1px solid rgba(25, 181, 254, 1);*/
  border-radius: 50%;
  pointer-events: none;
  box-sizing: border-box;
  transition: 0.2s;
  /*transition-duration: 300ms;*/
  transition-timing-function: ease-out;
}
#pointer-label {
  position: relative;
  width: 34px;
  height: 13px;
  border: solid 1px #FFFF00;
  font-size: 10px;
  font-family: Arial;
  font-weight: bold;
  line-height: 15px;
  text-align: center;
  top: -15px; /** original: -10px */
  left: 15px; /** original: 20px */
  background-color: #FFFFE0;
}
#adminPointer {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-32%, -10%);
  width: 20px;
  height: 20px;
  display: none;
  z-index: 1000;
  /*background: rgba(25, 181, 254, 1);*/
  /*background-image: url('../assets/cursor-default-outline.png');*/
  background-size: cover;
  /*border: 1px solid rgba(25, 181, 254, 1);*/
  border-radius: 50%;
  pointer-events: none;
  box-sizing: border-box;
  transition: 0.2s;
  /*transition-duration: 300ms;*/
  transition-timing-function: ease-out;
}
#adminPointer-label {
  position: relative;
  width: 34px;
  height: 13px;
  border: solid 1px #00FF00;
  font-size: 10px;
  font-family: Arial;
  font-weight: bold;
  line-height: 15px;
  text-align: center;
  top: -15px;
  left: 15px;
  background-color: #90EE90;
}
.cursorClick {
  display: none;
}
.cursorClick::after {
  content: "";
  position: absolute;
  top: -3px;
  left: 0px;
  width: 10px;
  height: 10px;
  border: 2px solid red;
  border-radius: 50%;
  animation-name: cursorAnim2;
  animation-duration: .5s;
  animation-fill-mode: forwards;
  opacity: .8;
}

.cursorClickAdmin {
  display: none;
}
.cursorClickAdmin::after {
  content: "";
  position: absolute;
  top: -3px;
  left: 0px;
  width: 10px;
  height: 10px;
  border: 2px solid red;
  border-radius: 50%;
  animation-name: cursorAnim2;
  animation-duration: .5s;
  animation-fill-mode: forwards;
  opacity: .8;
}

@keyframes cursorAnim2 {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(3);
  }
  100% {
    transform: scale(1);
    opacity: 0;
  }
}
.screen-text{
	width:170px;
}
#logo{
background-image:url('../assets/FWD_logo.png');
background-size: 100% 100%;
width:120px;
height:100%;
}
</style>
